import React, { useState } from 'react';
import {
    Table,
    Typography,
    Tag,
    Tooltip,
    Button,
    Space,
    Badge,
    Input,
    Select
} from '@douyinfe/semi-ui';
import {
    IconEyeOpened,
    IconEyeClosed,
    IconSearch,
    IconFilter
} from '@douyinfe/semi-icons';
import { formatAmountZhCn,renderLoanStatusTag, formatDate,   } from "../../../utils";

const { Text } = Typography;

export interface InterestPlanTableProps {
    data: any[];
    title?: string;
    loading?: boolean;
    height?: number;
}

const InterestPlanTable: React.FC<InterestPlanTableProps> = ({ data, title, loading = false, height = 600 }) => {
    const [searchText, setSearchText] = useState('');
    const [selectedLoanType, setSelectedLoanType] = useState<string>('');
    
    // 渲染贷款类型标签
    const renderLoanTypeTag = (type: string) => {
        const typeConfig: Record<string, { color: any; text: string }> = {
            'MORTGAGE': { color: 'blue', text: '信贷' },
            'CARD': { color: 'green', text: '信用卡' },
            'BORROW': { color: 'orange', text: '借款' }
        };
        
        const config = typeConfig[type] || { color: 'default', text: type };
        return <Tag color={config.color}>{config.text}</Tag>;
    };
    
   
    
    // 过滤数据
    const filteredData = data.filter(item => {
        // 按搜索文本过滤
        if (searchText) {
            const searchLower = searchText.toLowerCase();
            return (
                item.platform?.toLowerCase().includes(searchLower) ||
                item.loanNo?.toLowerCase().includes(searchLower) ||
                item.loanType?.toLowerCase().includes(searchLower)
            );
        }
        
        // 按贷款类型过滤
        if (selectedLoanType) {
            return item.loanType === selectedLoanType;
        }
        
        return true;
    });
    
    
    // 还款计划列定义
    const planColumns = [

        {
            title: '计息日期',
            dataIndex: 'interestStartDate',
            key: 'interestStartDate',
            width: 120,
            sorter: (a, b) => (a.interestStartDate - b.interestStartDate > 0 ? 1 : -1),
            render: (value: string, row:any) => formatDate(row.interestStartDate) 
        },
       
        {
            title: '利息天数',
            dataIndex: 'interestDays',
            key: 'interestDays',
            width: 150,
            render: (value: number,row:any) =>{
                if(row.paidMethod=='C_GZ_DH'){
                    return '过账代还'
                }else{
                    return value ?  '至' +formatDate(row.interestEndDate)+'('+row.interestEndDateDesc+')'+`  ${value}天` : '-'
                }
                
            } 
        },
        {
            title: '计息金额',
            dataIndex: 'interestAmount',
            key: 'interestAmount',
            width: 100,
            render: (value: number) => formatAmountZhCn(value)
        },
       
        {
            title: '利率',
            dataIndex: 'interestRate',
            key: 'interestRate',
            width: 100,
            
        },
        {
            title: '利息',
            dataIndex: 'interest',
            key: 'interest',
            width: 100,
            render: (value: number) => (
                <Text type="warning">
                    {formatAmountZhCn(value || 0)}
                </Text>
            )
        },
        
        // {
        //     title: '还款说明',
        //     dataIndex: 'paidMethod',
        //     key: 'paidMethod',
        //     width: 320,
        //     render: renderPaidDesc
        // },
        
        
    ];
    
    return (
        <div className="loan-plan-table">
            <div className="table-header">
                <Space>
                    {/* <Input
                        prefix={<IconSearch />}
                        placeholder="搜索平台、贷款编号..."
                        value={searchText}
                        onChange={setSearchText}
                        showClear
                    />
                    
                    <Select
                        placeholder="筛选贷款类型"
                        value={selectedLoanType}
                        onChange={setSelectedLoanType}
                        style={{width:'200px'}}
                        optionList={[
                            { label: '全部', value: '' },
                            { label: '信贷', value: 'MORTGAGE' },
                            { label: '信用卡', value: 'CARD' },
                            { label: '借款', value: 'BORROW' }
                        ]}
                        prefix={<IconFilter />}
                        showClear
                    /> */}
                     <Typography.Title heading={5}>{title}</Typography.Title>
                    <Button type="secondary" disabled={loading}>
                        共 {filteredData.length} 笔计息
                    </Button>
                </Space>
            </div>
            
            <Table
                bordered
                columns={planColumns}
                dataSource={filteredData}
                rowKey="planId"
                loading={loading}
                pagination={false}
                scroll={{ y: height }}
            />
        </div>
    );
};

export default InterestPlanTable;